export default __webpack_public_path__ + "static/media/icon_success.be6e3038.svg";